export const IssueTransitions = {
  pendingResolution: {
    transitionString: 'Pending Resolution',
    transitionAction: 'pending_resolution',
    confirmationMessage: () => {
      return "This will move the issue into the status of 'Resolution Pending'. Are you sure?"
    },
  },
  resolve: {
    transitionString: 'Resolve',
    transitionAction: 'resolve',
    confirmationMessage: () => {
      return 'This will close the issue and mark it as resolved. Are you sure?'
    },
  },
  reject: {
    transitionString: 'Reject',
    transitionAction: 'reject',
    confirmationMessage: () => {
      return 'This will close the issue and mark it as rejected. Are you sure?'
    },
  },
}

export const IssueFSMTransitions: Record<string, any> = {
  REPORTED: [IssueTransitions.pendingResolution, IssueTransitions.resolve, IssueTransitions.reject],
  RESOLUTION_PENDING: [IssueTransitions.resolve, IssueTransitions.reject],
}

export const getIssueTransitionProps = (issue: any) => {
  const status = issue.status
  if (!Object.keys(IssueFSMTransitions).includes(status)) {
    return null
  }
  return IssueFSMTransitions[status]
}
